import React from 'react';
import { Icon } from '@si-armes/dsfr-react';

const STATUT_STOCK = 1;
const STATUT_DEPOT_VENTE = 2;
const STATUT_REPARATION_MODIFICATION = 3;
export const STATUT_TRANSFERT = 4;
const STATUT_ATTENTE_DE_VALIDATION = 5;
const STATUT_PERDUE_OU_VOLEE = 6;
const STATUT_FIN_DE_VIE = 7;
const STATUT_DETRUITE = 8;
const STATUT_VENTE_ENTRE_PARTICULIERS = 10;
const STATUT_SUPPRIMEE = 11;
const STATUT_PRET = 13;
const STATUT_DEMANDE_SUPPRESSION = 14;

const LIBELLE_IS_PROPRIETAIRE = 'isProprietaire';
const LIBELLE_IS_LOCALISATION = 'isLocalisation';
const LIBELLE_STATUT_COURANT = 'statutCourant';
const LIBELLE_IS_A_REGULARISER = 'isARegulariser';

export const LIBELLE_DETENUE = 'Détenue';
const LIBELLE_DEPOT = 'Dépôt';
const LIBELLE_REPARATION_MODIFICATION = 'Réparation / modification';
export const LIBELLE_EXPEDITION_EN_COURS = 'Expédition en cours';
const LIBELLE_VALIDER_CESSION = 'Valider la cession';
export const LIBELLE_VALIDER_ACQUISITION = "Valider l'acquisition";
const LIBELLE_PERDUE_VOLEE = 'Perdue / volée';
const LIBELLE_VENTE_ETRANGER = "Vente à l'étranger";
const LIBELLE_DETRUITE = 'Détruite';
const LIBELLE_VENTE_ENTRE_PARTICULIERS = 'vente entre particulier';
const LIBELLE_SUPPRIMEE = 'Supprimée';
const LIBELLE_PRETER_PAR_PROFESSIONNEL = 'Prêtée par un professionnel';
export const LIBELLE_PRET = 'Prêt';
const LIBELLE_DEMANDE_SUPPRESSION = 'En attente de suppression';
export const LIBELLE_A_REGULARISER = 'A régulariser';
export const LIBELLE_A_CORRIGER = 'A corriger';

export const statutsArmes = [
    {
        libelle: '',
        value: 0,
    },
    {
        libelle: 'A régulariser',
        value: 'A régulariser',
    },
    {
        libelle: 'Détenue',
        value: 'Détenue',
    },
    {
        libelle: 'Dépôt',
        value: 'Dépôt',
    },
    {
        libelle: 'Réparation / modification',
        value: 'Réparation / modification',
    },
    {
        libelle: 'Expédition en cours',
        value: 'Expédition en cours',
    },
    {
        libelle: "Valider l'acquisition",
        value: "Valider l'acquisition",
    },
    {
        libelle: 'Valider la cession',
        value: 'Valider la cession',
    },
    {
        libelle: 'Perdue / volée',
        value: 'Perdue / volée',
    },
    {
        libelle: "Vente à l'étranger",
        value: "Vente à l'étranger",
    },
    {
        libelle: 'Détruite',
        value: 'Détruite',
    },
    {
        libelle: 'vente entre particulier',
        value: 'vente entre particulier',
    },
    {
        libelle: 'Supprimée',
        value: 'Supprimée',
    },
    {
        libelle: 'Prêtée par un professionnel',
        value: 'Prêtée par un professionnel',
    },
    {
        libelle: 'Prêt',
        value: 'Prêt',
    },
    {
        libelle: 'En attente de suppression',
        value: 'En attente de suppression',
    },
];

export const statutsHistoriqueArmes = [
    {
        libelle: '',
        value: '',
    },
    {
        libelle: 'Perdue / volée',
        value: 'Perdue / volée',
    },
    {
        libelle: 'Détruite',
        value: 'Détruite',
    },
    {
        libelle: 'Supprimée',
        value: 'Supprimée',
    },
    {
        libelle: 'Transférée',
        value: 'Transférée',
    },
];

export const displayLibelle = (libelle, isLocalisation, isIcone) => {
    if (isIcone) {
        return (
            <>
                {libelle}
                {isLocalisation && <Icon icon="fr-fi-user-fill" />}
            </>
        );
    }
    return libelle;
};

export const setTableauStatutsArmes = (listeArmes, isIcone) => {
    const tableArmes = listeArmes;
    for (let i = 0; i < tableArmes.length; i += 1) {
        tableArmes[i].statutLibelle = displayLibelle(
            tableArmes[i].statut,
            tableArmes[i].isLocalisation,
            isIcone,
        );
    }
    return tableArmes;
};

export const rechercheStatut = (libelle, value) => {
    return `${libelle}=${value}`;
};

export const rechercheStatuts = (rechercheValue) => {
    let suffixeUrlRechercheStatuts = '';
    switch (rechercheValue[1]) {
        case LIBELLE_DETENUE:
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_IS_PROPRIETAIRE, true);
            suffixeUrlRechercheStatuts += '&';
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_IS_LOCALISATION, true);
            suffixeUrlRechercheStatuts += '&';
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_STATUT_COURANT, STATUT_STOCK);
            suffixeUrlRechercheStatuts += '&';
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_IS_A_REGULARISER, false);
            break;
        case LIBELLE_DEPOT:
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_IS_PROPRIETAIRE, true);
            suffixeUrlRechercheStatuts += '&';
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_IS_LOCALISATION, false);
            suffixeUrlRechercheStatuts += '&';
            suffixeUrlRechercheStatuts += rechercheStatut(
                LIBELLE_STATUT_COURANT,
                STATUT_DEPOT_VENTE,
            );
            break;
        case LIBELLE_REPARATION_MODIFICATION:
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_IS_PROPRIETAIRE, true);
            suffixeUrlRechercheStatuts += '&';
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_IS_LOCALISATION, false);
            suffixeUrlRechercheStatuts += '&';
            suffixeUrlRechercheStatuts += rechercheStatut(
                LIBELLE_STATUT_COURANT,
                STATUT_REPARATION_MODIFICATION,
            );
            break;
        case LIBELLE_EXPEDITION_EN_COURS:
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_IS_PROPRIETAIRE, true);
            suffixeUrlRechercheStatuts += '&';
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_IS_LOCALISATION, true);
            suffixeUrlRechercheStatuts += '&';
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_STATUT_COURANT, STATUT_TRANSFERT);
            break;
        case LIBELLE_VALIDER_ACQUISITION:
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_IS_PROPRIETAIRE, false);
            suffixeUrlRechercheStatuts += '&';
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_IS_LOCALISATION, false);
            suffixeUrlRechercheStatuts += '&';
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_STATUT_COURANT, STATUT_TRANSFERT);
            break;
        case LIBELLE_VALIDER_CESSION:
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_IS_PROPRIETAIRE, true);
            suffixeUrlRechercheStatuts += '&';
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_IS_LOCALISATION, true);
            suffixeUrlRechercheStatuts += '&';
            suffixeUrlRechercheStatuts += rechercheStatut(
                LIBELLE_STATUT_COURANT,
                STATUT_ATTENTE_DE_VALIDATION,
            );
            break;
        case LIBELLE_PERDUE_VOLEE:
            suffixeUrlRechercheStatuts += rechercheStatut(
                LIBELLE_STATUT_COURANT,
                STATUT_PERDUE_OU_VOLEE,
            );
            break;
        case LIBELLE_VENTE_ETRANGER:
            suffixeUrlRechercheStatuts += rechercheStatut(
                LIBELLE_STATUT_COURANT,
                STATUT_FIN_DE_VIE,
            );
            break;
        case LIBELLE_DETRUITE:
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_STATUT_COURANT, STATUT_DETRUITE);
            break;
        case LIBELLE_VENTE_ENTRE_PARTICULIERS:
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_IS_PROPRIETAIRE, true);
            suffixeUrlRechercheStatuts += '&';
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_IS_LOCALISATION, false);
            suffixeUrlRechercheStatuts += '&';
            suffixeUrlRechercheStatuts += rechercheStatut(
                LIBELLE_STATUT_COURANT,
                STATUT_VENTE_ENTRE_PARTICULIERS,
            );
            break;
        case LIBELLE_SUPPRIMEE:
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_STATUT_COURANT, STATUT_SUPPRIMEE);
            break;
        case LIBELLE_PRETER_PAR_PROFESSIONNEL:
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_IS_PROPRIETAIRE, false);
            suffixeUrlRechercheStatuts += '&';
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_IS_LOCALISATION, true);
            suffixeUrlRechercheStatuts += '&';
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_STATUT_COURANT, STATUT_PRET);
            break;
        case LIBELLE_PRET:
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_IS_PROPRIETAIRE, true);
            suffixeUrlRechercheStatuts += '&';
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_IS_LOCALISATION, false);
            suffixeUrlRechercheStatuts += '&';
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_STATUT_COURANT, STATUT_PRET);
            break;
        case LIBELLE_DEMANDE_SUPPRESSION:
            suffixeUrlRechercheStatuts += rechercheStatut(
                LIBELLE_STATUT_COURANT,
                STATUT_DEMANDE_SUPPRESSION,
            );
            break;
        case LIBELLE_A_REGULARISER:
            suffixeUrlRechercheStatuts += rechercheStatut(LIBELLE_IS_A_REGULARISER, true);
            break;
        default:
            return suffixeUrlRechercheStatuts;
    }
    return suffixeUrlRechercheStatuts;
};
